import React from 'react';
import PropTypes from 'prop-types';
import Link from '../Link/Link';

/**
 * A component for navigating between routes
 */
function PrimaryLink({ href, iconType, iconPosition, title, target, hiddenText, children }) {
  return (
    <Link
      href={href}
      asButton={true}
      iconType={iconType}
      iconPosition={iconPosition}
      title={title}
      target={target}
      hiddenText={hiddenText}
    >
      {children}
    </Link>
  );
}

PrimaryLink.propTypes = {
  /**
   * The destination of the link
   */
  href: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      hash: PropTypes.string
    })
  ]).isRequired,
  /**
   * The type of icon to display
   */
  iconType: PropTypes.string,
  /**
   * The positioning of the icon
   */
  iconPosition: PropTypes.oneOf(['left', 'right']),
  /**
   * The title of the link
   */
  title: PropTypes.string,
  /**
   * The target of the link
   */
  target: PropTypes.string,
  /**
   * The hidden text for screenreaders
   */
  hiddenText: PropTypes.string,
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default PrimaryLink;
